import React from 'react';
import CrudGenerator from 'admin/pages/shared/CrudGenerator/CrudGenerator';
import { columns, formSchema } from './BigQueryQueriesConfig';
import BigQueryQueriesService from './BigQueryQueriesService';
import './style.scss';

export default CrudGenerator({
    columns,
    formSchema,
    defaultNewEntity: { name: "" },
    route: '/admin/bigquery-queries',
    entityName: {
        entityNamePlural: "BigQuery Queries",
        entityNameSingular: "BigQuery Query"
    },
    createEntity: BigQueryQueriesService.createBigQueryQuery,
    getEntities: BigQueryQueriesService.getBigQueryQueries,
    editEntity: BigQueryQueriesService.editBigQueryQueries,
    deleteEntities: BigQueryQueriesService.deleteBigQueryQueries,
    defaultShowAddEditExpandButton: false,
    addEditModalFooter: null
})